import "./HomePage.css";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
    const navigate = useNavigate();

    return (
        <div className="home-container">
            <h1 className="home-title">Mirësevini në Rental Manager</h1>

            <p className="home-subtitle">
                Menaxhoni apartamentet, qiramarrësit dhe pagesat në mënyrë të thjeshtë dhe të shpejtë.
            </p>

            <div className="home-grid">

                <div className="home-card" onClick={() => navigate("/apartments")}>
                    <div className="home-card-icon">🏢</div>
                    <div className="home-card-title">Apartamente</div>
                </div>

                <div className="home-card" onClick={() => navigate("/tenants")}>
                    <div className="home-card-icon">👤</div>
                    <div className="home-card-title">Qiramarrës</div>
                </div>

                <div className="home-card" onClick={() => navigate("/payment-manager")}>
                    <div className="home-card-icon">💳</div>
                    <div className="home-card-title">Regjistro Pagesë</div>
                </div>

                <div className="home-card" onClick={() => navigate("/payment-list")}>
                    <div className="home-card-icon">📄</div>
                    <div className="home-card-title">Lista e Pagesave</div>
                </div>

                <div className="home-card" onClick={() => navigate("/dashboard")}>
                    <div className="home-card-icon">📊</div>
                    <div className="home-card-title">Paneli Statistik</div>
                </div>

            </div>
        </div>
    );
}
